import { ReactNode } from 'react'
import { Badge } from '@/ui/components/'
import { cn } from '@/shared/utils'

interface StatusBadgeProps {
  status: 'upcoming' | 'active' | 'completed' | 'cancelled' | 'success' | 'warning' | 'error' | 'info'
  children: ReactNode
  className?: string
}

export function StatusBadge({ status, children, className }: StatusBadgeProps) {
  const statusClasses = {
    upcoming: 'status-upcoming',
    active: 'status-active',
    completed: 'status-completed',
    cancelled: 'status-cancelled',
    success: 'status-success',
    warning: 'status-warning',
    error: 'status-error',
    info: 'status-info'
  }

  return (
    <Badge className={cn(statusClasses[status], className)}>
      {children}
    </Badge>
  )
}
